module.exports = __webpack_public_path__ + "img/dinggou.0961157a.svg";